<ng-container *ngIf="statusPointsState$ | async as statusPoints">
  <div>
    <ng-container *ngIf="statusPoints.isLoading">
      <spinner fixed="true"></spinner>
    </ng-container>

    <ng-container>
      <div class="loyalty-wrap business-wrap">
        <div *ngIf="!isSnow" class="amadeus-direct-style">
          <div class="row">
            <img
              class="img-fluid col-lg-12 mx-0 px-0 g-0"
              alt="Responsive banner"
              src="/assets/images/banner/plusme-banner.png"
            />
          </div>
        </div>
        <div class="container first-agent-body pt-lg-9 px-lg-10 pt-md-9 px-md-10">
          <div class="row px-lg-8 px-md-8">
            <div class="col-12">
              <h1 i18n="@@loyalty-status-points.loyaltyInnerPageStatusPoints">Status Points</h1>
              <p i18n="@@loyalty-status-points.loyaltyInnerPageFindStatusPoints">
                You can find here your point status report
              </p>
            </div>
            <div class="col-12">
              <form (ngSubmit)="handleSubmit()" [formGroup]="fg" appConnectForm autocomplete="off">
                <div class="row mb-5">
                  <p-form-group label="{{ accountStatusSearchBy }}" class="col-12 col-md-3">
                    <ng-select
                      id="search-by"
                      formControlName="searchBy"
                      [items]="searchOptions"
                      [searchable]="false"
                      [clearable]="false"
                      class="dashboard-select"
                    >
                    </ng-select>
                  </p-form-group>

                  <p-form-group
                    label="{{ accountStatusPnrNumber }}"
                    class="col-12 col-md-3"
                    *ngIf="fg.get('searchBy')?.value?.value === 'pnr'"
                    formGroupName="searchWithPNR"
                  >
                    <input
                      type="text"
                      class="form-control textbox-pnr-number"
                      formControlName="pnrNo"
                      id="search"
                      autocomplete="off"
                      i18n-placeholder="@@loyalty-status-points.accountStatusPnrNumber"
                      placeholder="PNR number"
                    />
                  </p-form-group>

                  <p-form-group
                    label="{{ accountStatusFrom }}"
                    class="col-12 col-md-3"
                    *ngIf="fg.get('searchBy')?.value?.value === 'date'"
                    formGroupName="searchWithDate"
                  >
                    <div class="input-group dashboard-datepicker">
                      <input
                        class="form-control"
                        pFormControlInput
                        formControlName="from"
                        name="fromDate"
                        id="fromDate"
                        placeholder="YY-MM-DD"
                        autocomplete="off"
                        ngbDatepicker
                        #dp="ngbDatepicker"
                        [autoClose]="true"
                        outsideDays="collapsed"
                        (keyup.enter)="dp.onBlur()"
                      />
                      <button
                        type="button"
                        class="fa-calendar btn-placement-hebrew"
                        title="Toggle calendar"
                        (click)="dp.toggle()"
                      ></button>
                    </div>
                  </p-form-group>
                  <p-form-group
                    label="{{ accountStatusTo }}"
                    class="col-12 col-md-3"
                    *ngIf="fg.get('searchBy')?.value?.value === 'date'"
                    formGroupName="searchWithDate"
                  >
                    <div class="input-group dashboard-datepicker">
                      <input
                        class="form-control"
                        pFormControlInput
                        formControlName="to"
                        name="toDate"
                        id="toDate"
                        placeholder="YY-MM-DD"
                        autocomplete="off"
                        ngbDatepicker
                        #dp2="ngbDatepicker"
                        [autoClose]="true"
                        outsideDays="collapsed"
                        (keyup.enter)="dp2.onBlur()"
                      />
                      <button
                        type="button"
                        class="fa-calendar btn-placement-hebrew"
                        title="Toggle calendar"
                        (click)="dp2.toggle()"
                      ></button>
                    </div>
                  </p-form-group>

                  <div class="form-footer col-12 col-md-2 d-flex align-items-end">
                    <div class="d-grid w-100">
                      <button type="submit" class="btn interactive" i18n="@@loyalty-status-points.commonSearch">
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </form>
              <div
                *ngIf="!statusPoints.isLoading"
                [ngClass]="statusPoints.data.noneDet === 'none' ? 'd-none' : ''"
                class="row"
              >
                <div class="col-12 col-sm-6 loyalty-table-container">
                  <table>
                    <thead>
                      <tr>
                        <td>
                          <div class="table-title" i18n="@@loyalty-status-points.accountFirstPointsBalance">
                            Points Balance
                          </div>
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td i18n="@@loyalty-status-points.accountFirstSegments">Segments</td>
                        <td>
                          {{ statusPoints.data.totlegsOK | number }}
                          <em
                            class="tip"
                            data-html="true"
                            data-toggle="tooltip"
                            data-placement="top"
                            container="body"
                            [ngbTooltip]="htmlContentValidated"
                          ></em>
                        </td>
                      </tr>
                      <tr>
                        <td i18n="@@loyalty-status-points.accountFirstAccumulatedPoints">Accumulated</td>
                        <td>
                          {{ statusPoints.data.totpoints | number }}
                          <em
                            class="tip"
                            data-html="true"
                            data-toggle="tooltip"
                            data-placement="top"
                            container="body"
                            [ngbTooltip]="htmlContentAccumulated"
                          ></em>
                        </td>
                      </tr>
                      <tr>
                        <td i18n="@@loyalty-status-points.accountFirstAdditional">
                          Additional
                        </td>
                        <td>
                          {{ statusPoints.data.summAdd | number }}
                          <em
                            class="tip"
                            data-html="true"
                            data-toggle="tooltip"
                            data-placement="top"
                            container="body"
                            [ngbTooltip]="htmlContentAdditional"
                          ></em>
                        </td>
                      </tr>
                      <tr>
                        <td i18n="@@loyalty-status-points.accountFirstUsedPoints">
                          Used
                        </td>
                        <td>
                          {{ statusPoints.data.summUse | number }}
                          <em
                            class="tip"
                            data-html="true"
                            data-toggle="tooltip"
                            data-placement="top"
                            container="body"
                            [ngbTooltip]="htmlContentUsed"
                          ></em>
                        </td>
                      </tr>
                      <tr>
                        <td i18n="@@loyalty-status-points.accountFirstExpiredPoints">
                          Expired
                        </td>
                        <td>
                          {{ statusPoints.data.expired | number }}
                          <em
                            class="tip"
                            data-html="true"
                            data-toggle="tooltip"
                            data-placement="top"
                            container="body"
                            [ngbTooltip]="htmlContentExpired"
                          ></em>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong i18n="@@loyalty-status-points.accountFirstAvailablePoints">Available</strong>
                        </td>
                        <td>
                          <strong> {{ statusPoints.data.refresh | number }} </strong>
                          <em
                            class="tip"
                            data-html="true"
                            data-toggle="tooltip"
                            data-placement="top"
                            container="body"
                            [ngbTooltip]="htmlContentAvailable"
                          ></em>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div *ngIf="statusPoints.data.details && !statusPoints.isLoading">
                <ul ngbNav #nav="ngbNav" class="nav-tabs">
                  <li ngbNavItem>
                    <a ngbNavLink i18n="@@loyalty-status-points.accountStatusPNRPoints">PNR Points</a>
                    <ng-template ngbNavContent>
                      <div class="table-responsive">
                        <table class="table">
                          <thead class="thead-light">
                            <tr>
                              <th class="align-top" i18n="@@loyalty-status-points.accountStatusPNR">PNR</th>
                              <th class="align-top" i18n="@@loyalty-status-points.accountStatusCreationDate">
                                Creation Date
                              </th>
                              <th class="align-top" i18n="@@loyalty-status-points.accountStatusNumberOfSegments">
                                Number of segments
                              </th>
                              <th class="align-top" i18n="@@loyalty-status-points.accountStatusAccumulatedSegments">
                                Accumulated segments
                              </th>
                              <th class="align-top" i18n="@@loyalty-status-points.accountStatusValueOfSegments">
                                Value of Segments
                              </th>
                              <th class="align-top" i18n="@@loyalty-status-points.accountStatusCreditPoints">
                                Credit Points
                              </th>
                              <th class="align-top text-center" i18n="@@loyalty-status-points.accountStatusLabel">
                                Status
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let pts of statusPoints.data.points; trackBy: trackByPnrPoints">
                              <td class="" [innerHTML]="pts.pnr"></td>
                              <td class="nobr" [innerHTML]="pts.date | reefDate: 'longDate'"></td>
                              <td class="" [innerHTML]="pts.legs"></td>
                              <td class="" [innerHTML]="pts.legSOK"></td>
                              <td class="nobr" appRouteTransformer [innerHTML]="pts._Price || ''"></td>
                              <td class="" [innerHTML]="pts.points"></td>
                              <td class="text-center" [innerHTML]="pts.status"></td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colspan="3" class="align-bottom">
                                <strong i18n="@@loyalty-status-points.accountStatusTotalOfPNRs">Total of PNRs:</strong>
                              </th>
                              <th colspan="2" class="align-bottom">
                                <strong>{{ statusPoints.data.totlegsOK | number }}</strong>
                              </th>
                              <th colspan="2" class="align-bottom">
                                <strong>{{ statusPoints.data.totpoints | number }}</strong>
                              </th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </ng-template>
                  </li>
                  <li ngbNavItem>
                    <a ngbNavLink i18n="@@loyalty-status-points.accountStatusAdditionalPoints">Additional Points</a>
                    <ng-template ngbNavContent>
                      <div class="table-responsive table-wrapper-half">
                        <table class="table">
                          <thead class="thead-light">
                            <tr>
                              <th class="align-top" i18n="@@loyalty-status-points.accountStatusDate">Date</th>
                              <th
                                class="align-top"
                                i18n="@@loyalty-status-points.accountStatusAdditionalPointsInformation"
                              >
                                Additional points information
                              </th>
                              <th class="align-top text-center" i18n="@@loyalty-status-points.accountStatusPNR">PNR</th>
                              <th class="align-top table-text-align" i18n="@@loyalty-status-points.accountStatusPoints">
                                Points
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let add of statusPoints.data.addArray; trackBy: trackByAddPoints">
                              <td class="align-top nobr" [innerHTML]="add.date | reefDate: 'longDate'"></td>
                              <td class="align-top" [innerHTML]="add.description || ''" appRouteTransformer></td>
                              <td class="align-top text-center" [innerHTML]="add.pnr"></td>
                              <td class="align-top table-text-align">{{ add.points | number }}</td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colspan="2" class="align-bottom">
                                <strong i18n="@@loyalty-status-points.accountStatusTotalOfAdditionalPoints"
                                  >Total of additional points:</strong
                                >
                              </th>
                              <th colspan="2" class="align-bottom table-text-align">
                                <strong>{{ statusPoints.data.summAdd | number }}</strong>
                              </th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </ng-template>
                  </li>
                  <li ngbNavItem>
                    <a ngbNavLink>{{ accountStatusOrderedGifts }}</a>
                    <ng-template ngbNavContent>
                      <div class="table-responsive table-wrapper-half">
                        <table class="table">
                          <thead class="thead-light">
                            <tr>
                              <th class="align-top" i18n="@@loyalty-status-points.accountStatusOrderDate">
                                Order Date
                              </th>
                              <th class="align-top" i18n="@@loyalty-status-points.accountStatusGiftName">Gift Name</th>
                              <th class="align-top" i18n="@@loyalty-status-points.accountStatusQuantity">Quantity</th>
                              <th
                                class="align-top table-text-align"
                                i18n="@@loyalty-status-points.accountStatusPointsUsed"
                              >
                                Points Used
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let use of statusPoints.data.useArray; trackBy: trackByOrderedGifts">
                              <td class="nobr" [innerHTML]="use.date | reefDate: 'longDate'"></td>
                              <td class="" [innerHTML]="use.pnr" appRouteTransformer></td>
                              <td class="text-center" [innerHTML]="use.quantity"></td>
                              <td class="table-text-align">
                                {{ use.points | number }}
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colspan="2" class="align-bottom">
                                <strong i18n="@@loyalty-status-points.accountStatusTotalOfUsedPoints"
                                  >Total Of Used Points:</strong
                                >
                              </th>
                              <th colspan="2" class="align-bottom table-text-align">
                                <strong>{{ statusPoints.data.summUse | number }}</strong>
                              </th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </ng-template>
                  </li>
                </ul>
                <div [ngbNavOutlet]="nav"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <ng-template #loadingError>
    <loading-error [message]="statusPoints.loadingError"></loading-error>
  </ng-template>
</ng-container>

<ng-template #htmlContentPending>
  <div i18n="@@loyalty-status-points.accountFirstTooltipPending">Pending segments before departure</div>
</ng-template>

<ng-template #htmlContentValidated>
  <div i18n="@@loyalty-status-points.accountFirstTooltipValidated">Validated segments will be credited with points</div>
</ng-template>

<ng-template #htmlContentAccumulated>
  <div i18n="@@loyalty-status-points.accountFirstTooltipAccumulated">The amount of total points gained</div>
</ng-template>

<ng-template #htmlContentUsed>
  <div i18n="@@loyalty-status-points.accountFirstTooltipUsed">Points redeemed for gift orders</div>
</ng-template>

<ng-template #htmlContentExpired>
  <div i18n="@@loyalty-status-points.accountFirstTooltipExpired">
    Credit points will expire three (3) years following the date they are credited to your Amadeus+Me account.
  </div>
</ng-template>

<ng-template #htmlContentAvailable>
  <div i18n="@@loyalty-status-points.accountFirstTooltipAvailable">
    The remaining available points that can be redeemed
  </div>
</ng-template>

<ng-template #htmlContentRegular>
  <div i18n="@@loyalty-status-points.accountFirstTooltipRegular">Total points accumulated</div>
</ng-template>

<ng-template #htmlContentAdditional>
  <div i18n="@@loyalty-status-points.accountFirstTooltipAdditional">Additional bonus points</div>
</ng-template>
